export default __webpack_public_path__ + "static/media/miguel-lopes-20.56e99d26.jpg";